export const SUS_LAST_NAMES = [
    'Madden',
    'Garcia',
    'Hartley',
    'Marshall',
    'Ide',
    'Stuart',
    'Reyes',
    'Annis',
    'Valentine',
    'Bourgeois',
    'Degraw',
    'Frank',
    'Bee',
    'Norstrand',
    'White',
    'Harmon',
    'Ver',
    'Midkiff',
    'Przewozman',
    'Coats',
    'Mackay',
    'Dove',
    'Alamilla',
    'Likio',
    'Carpenter',
    'Campa',
    'Haas',
    'Dodson',
    'Cirillo',
    'Ward'
]